// extracted by mini-css-extract-plugin
export default {"icon":"c65kL","iconActive":"gndlA"};